import Typography from '@mui/material/Typography';
import React from 'react';

import WarningExclamation from '../../../assets/images/WarningExclamation';
import { KdModalType } from '../../../types/kdModal';
import KdModal from '../KdModal';

type Props = KdModalType & {
  /** Determines if the modal action buttons */
  actions?: React.ReactNode;
  /** The message modal description */
  description?: string;
  /** The message modal sub description */
  subDescription?: string;
  /** The message modal icon */
  icon?: React.ReactNode;
  /** The message modal title */
  title: string;
};

const descriptionClasses = `
  text-textXs
  leading-snug
  sm:text-textBase
`;

const actionsChildenClasses = `
  child:m-0 
  child:w-full
  nextChild:mt-[10px] 
  sm:child:w-auto
  sm:nextChild:mt-0
`;

const MessageModal: React.FC<Props> = ({
  actions,
  description,
  icon = <WarningExclamation className="w-[35px] sm:w-[50px]" />,
  subDescription,
  show,
  title,
  ...props
}) => (
  <KdModal
    show={show}
    className="text-center"
    {...props}
  >
    <div className="mb-[10px] sm:mb-[30px] flex justify-center">{icon}</div>
    <Typography
      className="text-[22px] sm:text-[25px] font-semibold"
      component="h4"
    >
      {title}
    </Typography>
    {description && (
      <p className={`${descriptionClasses} mt-[10px]`}>{description}</p>
    )}
    {subDescription && (
      <p className={`${descriptionClasses} mt-[5px]`}>{subDescription}</p>
    )}
    {actions && (
      <div
        className={`sm:flex 
            sm:justify-center 
            gap-[30px] 
            mt-[20px] 
            sm:mt-[30px] 
            ${actionsChildenClasses}
          `}
      >
        {actions}
      </div>
    )}
  </KdModal>
);

export default MessageModal;
